import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { AddressClient } from 'src/WebApiController';

export function useStateProvinces() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const query = useQuery({
    queryKey: [
      'getStateProvinces',
      activeAccountWebClientConfig.activeAccountId,
    ],
    queryFn: async () => {
      if (activeAccountWebClientConfig.activeAccountId == null) {
        return null;
      }
      return await new AddressClient(
        activeAccountWebClientConfig
      ).getStateProvinces();
    },

    enabled: activeAccountWebClientConfig.activeAccountId != null,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    meta: {
      persist: true,
      onError: (error: ErrorTypes) => {
        showErrorDialog('AddressClient.getStateProvinces', error);
      },
    },
  });

  return query;
}
